import {
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from 'react-redux'

import { TracFloState } from "../types/state"

export const useTracFloSelector: TypedUseSelectorHook<TracFloState> = useReduxSelector